/** Start number confirmation after check-in (Participants + Competitions). */
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';

interface Props {
  handleClose: () => void;
  open: boolean;
  serialNo?: number | string;
}

const CheckinSerialModal = ({ handleClose, open, serialNo = '-' }: Props) => {
  const { t } = useTranslation();
  return (
    <EditorDialogShell
      open={open}
      onClose={handleClose}
      id="checkin-ser"
      title={t('checkins.checkinSerial')}
      maxWidth="xs"
    >
      <Typography sx={{ mt: 2, fontSize: 72 }} align="center">
        {serialNo}
      </Typography>
    </EditorDialogShell>
  );
};

export default CheckinSerialModal;
